var routeActions = require('react-router-redux').routerActions;
var api = require('../../../utils/api');
var constants = require('../constants');
var surveyActions = require('../../survey/actions/surveys-initialize');
var commonActions = require('../../common/actions/common');
var dashboardActions = require('../../dashboard/actions/dashboard');
var surveyMetaActions = require('../../meta/actions/survey');

var PostResponse = (function() {
    
    var _surveyType2SubmissionType = {
        'promis': 'PROMIS', // Symptom Tracker
        'myqol': 'MQOL', // MyQ Quality of Life
        'gihistory': 'GIHistory', // Doctor Visit Preparation
        'nhs2': 'NHS2' // National Health Survey 2
    };

/*    var _surveyType2DashboardType = {
        'promis': 'mygi',
        'myqol': 'myqol',
        'gihistory': 'doctor-visit',
        'nhs2': 'NHS2' // National Health Survey 2
    }; */

    var _submissionRequest = function() {
        return {
            type: constants.SUBMISSION_REQUEST
        };
    }

    var _submissionSuccess = function(cta) {
        return {
            type: constants.SUBMISSION_SUCCESS,
            cta,
        };
    }

    var _submissionError = function(error) {
        return {
            type: constants.SUBMISSION_ERROR,
            errors: error.data
        };
    }

    var _calculateCTA = function(submission) {
        const Q5 = submission.find(item => item[1] === 'Q5') || []; // In the past 7 days...
        const Q30 = submission.find(item => item[1] === 'Q30') || []; // Are you currently taking an opioid medication...
        const Q34 = submission.find(item => item[1] === 'Q34') || []; // Has a healthcare provider ever diagnosed you...
        const Q35 = submission.find(item => item[1] === 'Q35') || []; // Has a healthcare provider ever diagnosed you...        
        const Q39 = submission.find(item => item[1] === 'Q39') || []; // ...proton-pump inhibitor medicines...

        const {2: Q5Response = [] } = Q5;
        const {2: Q30Response = [] } = Q30;
        const {2: Q34Response = [] } = Q34;
        const {2: Q35Response = [] } = Q35;
        const {2: Q39Response = [] } = Q39;

        // Plush variables
        const Q5PlushValues = [0, 1, 7];
        const Q5HasPlushValues = Q5Response.some(item => Q5PlushValues.indexOf(item.value) >= 0) || false;
        // console.log('Q5 plush: ', Q5HasPlushValues);
        
        const Q30PlushExcludes = [1];
        const Q30HasPlushExcludes = Q30Response.some(item => Q30PlushExcludes.indexOf(item.value) >= 0) || false
        // console.log('Q30 plush excludes: ', Q30HasPlushExcludes);

        const Q34PlushValues = [3, 10];
        const Q34HasPlushValues = Q34Response.some(item => Q34PlushValues.indexOf(item.value) >= 0) || false;
        // console.log('Q34 plush: ', Q34HasPlushValues);

        const Q35PlushExclude = [0];
        const Q35HasPlushExcludes = Q35Response.some(item => Q35PlushExclude.indexOf(item.value) >= 0) || false;
        // console.log('Q35 plush excludes: ', Q35HasPlushExcludes);

        // GERD variables
        const Q5GerdValues = [4, 5];
        const Q5HasGerdValues = Q5Response.some(item => Q5GerdValues.indexOf(item.value) >= 0) || false;
        // console.log('Q5 gerd: ', Q5HasGerdValues);

        const Q34GerdValues = [6, 8];
        const Q34GerdExclude = [9];
        const Q34HasGerdValues = Q34Response.some(item => Q34GerdValues.indexOf(item.value) >= 0) || false;
        const Q34HasGerdExcludes = Q34Response.some(item => Q34GerdExclude.indexOf(item.value) >= 0) || false;
        // console.log('Q34 gerd: ', Q34HasGerdValues);
        // console.log('Q34 gerd excludes: ', Q34HasGerdExcludes);

        //const Q35GerdValues = [6, 8];
        const Q35GerdExclude = [7, 9];
        const Q35HasGerdExcludes = Q35Response.some(item => Q35GerdExclude.indexOf(item.value) >= 0) || false;
        // console.log('Q35 gerd excludes: ', Q35HasGerdExcludes);

        const Q39GerdValues = [0, 1, 2, 3, 4, 5, 6, 7];
        const Q39HasGerdValues = Q39Response.some(item => Q39GerdValues.indexOf(item.value) >= 0) || false;
        // console.log('Q39 gerd: ', Q39HasGerdValues);         

        // See if user qualifies for PlushCare (priority over GERD)
        if ((Q5HasPlushValues || Q34HasPlushValues) && !Q30HasPlushExcludes && !Q35HasPlushExcludes) {
            // console.log('plush');
            // console.log('Q5: ', Q5HasPlushValues, ' / Q34: ', Q34HasPlushValues, ' / Q30: ', Q30HasPlushExcludes, ' / Q35: ', Q35HasPlushExcludes);
            return 'plush';
        }

        // See if user qualifies for GERD trial
        if ((Q5HasGerdValues || Q34HasGerdValues) && Q39HasGerdValues && !Q34HasGerdExcludes && !Q35HasGerdExcludes) {
            // console.log('gerd');
            // console.log('Q5: ', Q5HasGerdValues, ' / Q34: ', Q34HasGerdValues, ' / Q39: ', Q39HasGerdValues, ' / Q34: ', Q34HasGerdExcludes, ' / Q35: ', Q35HasGerdExcludes);            
            return 'gerd';
        }

        // User does not qualify for any trail
        // console.log('generic');
        return 'generic';
    }  

    var _prepareSubmission = function(submission, state) {
        var surveyId = null;
        var sub = [];
        var entities = state.entities;
        var submissionType = _surveyType2SubmissionType[state.surveys.surveyType];

        for (var i = 0; i < submission.length; i++) {
            var nextSurveyId = submission[i][0];
            if (nextSurveyId !== surveyId) {
                surveyId = nextSurveyId;

                var symptomId = entities.surveys[surveyId].symptom;
                var symptom = entities.symptoms[symptomId];
                // var calculateScores = entities.surveys[surveyId].calculateScores || false;

                var survey = {
                    id: surveyId,
                    name: entities.surveys[surveyId].name
                }

                sub.push({
                    survey: survey,
                    symptom: symptom,
                    // calculateScores: calculateScores,
                    data: []
                });
            }

            var ans = {
                fieldName: submission[i][1],
                response: submission[i][2]
            };
            sub[sub.length - 1].data.push(ans);

        }
        return { type: submissionType, responses: sub };
    }

    var _postSubmission = function(accessToken) {
        return function(dispatch, getState) {
            var state = getState();
            var submission = state.responses.submission;
            var sub = _prepareSubmission(submission, state);
            var cta = _calculateCTA(submission) || 'generic';
            
            dispatch(_submissionRequest());
            api.post('/proxy/v1/submissions', sub, accessToken)
                .then(function(res) {
                    dispatch(surveyMetaActions.recordSurveyCompleted(state.routing.locationBeforeTransitions.pathname.toLowerCase()));

                    dispatch(surveyActions.clearPreviousState());

/* Remove alarmSystemResponses                    
                    var alarmSymptomResponses = [];
                    for(var i = 0; i < submission.length; i++){
                        var submissionItem = submission[i];
                        if(submissionItem[1] === 'D2A'){
                            alarmSymptomResponses = submissionItem[2].filter(function(userResponse){
                                return userResponse.tag !== 'none';
                            });
                        }
                    }
                    dispatch(dashboardActions.setAlarmSymptomResponses(alarmSymptomResponses));
                    */

                    // cause the score is generated asynchronously, we need a delay here
                    setTimeout(function(){
                        dispatch(_submissionSuccess(cta));
                        //dispatch(routeActions.replace('/dashboard/' + _surveyType2DashboardType[state.surveys.surveyType]));
                        dispatch(routeActions.replace('/confirmation'));
                    }, 1000);
                })
                .catch(function(error) {
                    if(error.response){
                        dispatch(_submissionError(error.response));
                        dispatch(commonActions.setGenericResponseError('', error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        };
    }


    return {
        postSubmission: _postSubmission
    }
})();

module.exports = PostResponse;


// WEBPACK FOOTER //
// ./src/common/modules/responses/actions/post-responses.js